import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class ResetPasswordGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const token = route.queryParamMap.get('token');

    if (!token || !this.isValidJwt(token)) {
      this.router.navigate(['/login']);
      return false;
    }

    return true;
  }

  private isValidJwt(token: string): boolean {
    try {
      const parts = token.split('.');
      if (parts.length !== 3) return false;

      const payload = JSON.parse(atob(parts[1]));

      if (!payload.exp) return false;

      const now = Math.floor(Date.now() / 1000);

      if (payload.exp < now) {
        return false;
      }

      return true;
    } catch {
      return false;
    }
  }
}
